import React from 'react';

import {
  Container, Logo, MessageContainer, Title, Text, DescriptionContainer,
} from './styles';

const FullRoom = () => (
  <Container>
    <MessageContainer>
      <Logo src="/images/playbook-logo.png" alt="Playbook" />

      <DescriptionContainer>
        <Title>This live stream is currently at full capacity.</Title>
        <Text brspace={+true}>You&apos;ll be able to enter the live stream if a spot opens up due to someone leaving.</Text>
      </DescriptionContainer>
    </MessageContainer>
  </Container>
);

export default FullRoom;
